




























































































import {Component, Ref, Vue} from 'vue-property-decorator'
import CompanyApi from "@/module/device/CompanyApi";
import {Container} from "typescript-ioc";
import Company from "@/model/Company";
import Pagination from '@/component/Pagination/index.vue'
import DeleteDialog from "@/component/Crud/delete-dialog.vue";
import PaginationTable from "@/component/Table/pagination-table.vue";
import RefreshButton from "@/component/Button/refresh-button.vue";
import {CpqForm} from "@/form/CompanyForm";
import IdColumn from "@/component/Table/id-column.vue";

@Component({
  components: {
    IdColumn,
    Pagination,
    DeleteDialog,
    PaginationTable,
    RefreshButton,
  },
})
export default class CompanyView extends Vue {

  private companyApi = Container.get(CompanyApi)

  @Ref()
  private deleteDialog!: DeleteDialog

  @Ref()
  private ptable!: PaginationTable

  private company = new Company()

  private async confirmDelete() {
    await this.companyApi.delete(this.company.id)
  }

  private pqForm = new CpqForm()

  private async getPaging() {
    return this.companyApi.paging(this.pqForm)
  }

  private refresh() {
    this.ptable?.refresh()
  }

  private async handleDetailClick(company: Company) {
    this.$redirector.companyDetail({
      cid: company.id.toString(),
    })
  }

  private async handleDeleteClick(company: Company) {
    this.company = company
    this.deleteDialog.open()
  }
}
